<template>
  <div class="returnVisit">
    <div class="searchBox">
      <div class="twoBox">
        <van-dropdown-menu active-color="#236DFF">
          <van-dropdown-item v-model="value" :options="option" />
        </van-dropdown-menu>
        <input type="text" placeholder="请输入" v-model="searchValue" />
      </div>
      <van-button type="info" class="btn" @click="changeType">查询</van-button>
    </div>
    <van-tabs v-model="receiptRevisitStatus1" @change="changeType" color="#236DFF">
      <van-tab :title="titleTab(1)" name="1"></van-tab>
      <van-tab :title="titleTab(2)" name="2"></van-tab>
      <van-tab :title="titleTab(3)" name="3"></van-tab>
      <van-tab :title="titleTab(4)" name="4"></van-tab>
    </van-tabs>
    <van-list v-model="listLoading" :finished="finished" :finished-text="finishedText" @load="nextPage" class="listContent" :immediate-check="false">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="title">
          {{ item.productName }}
        </div>
        <div class="receiptRevisitStatus" :class="item.receiptRevisitStatus == 5 ? 'green' : ''">
          {{ item.receiptRevisitStatus | filterReturnVisitStatus1 }}
        </div>
        <div class="content">
          <div class="itemShow">
            <span class="itemName">保单号：</span>
            <span class="itemData">{{ item.policyNo }}</span>
          </div>
          <div class="itemShow">
            <span class="itemName">投/被保人：</span>
            <div class="itemData">
              <span v-if="item.holderName">{{ item.holderName }}</span>
              <span v-if="item.holderName && item.insuranceName">/</span>
              <span v-if="item.insuranceName">{{ item.insuranceName }}</span>
            </div>
          </div>
          <div class="itemShow">
            <span class="itemName">保单状态：</span>
            <span class="itemData" :class="item.status == '-1' || item.status == '0' ? 'red' : ''">{{
            POLICY_STATUS[item.status]
          }}</span>
          </div>
          <div class="itemShow">
            <span class="itemName">回执状态：</span>
            <span class="itemData">{{ RECEIPT_STATUS[item.receiptStatus] || '-' }}</span>
          </div>
          <div class="itemShow">
            <span class="itemName">回访状态：</span>
            <span class="itemData">{{ VERIFY_STATUS[item.revisitStatus] || '-' }}</span>
          </div>
          <div class="itemShow">
            <span class="itemName">最后回执回访时间：</span>
            <span class="itemData">{{ item.createTime | dateFormat('yyyy-MM-dd') }}</span>
          </div>
          <div class="itemShow">
            <span class="itemName">备注：</span>
            <span class="itemData">{{ item.remark }}</span>
          </div>
          <div v-if="item.receiptUrl && item.receiptStatus!=1" class="statusBox">
            <div class="item-box">
              <span class="title1">回执链接：</span>
              <img id="copy" @click="copy(item.receiptUrl)" src="@static/images/fuzhi.png" class="btn1" />
            </div>
            <div class="items">{{ item.receiptUrl }}</div>
          </div>
          <div v-if="item.receiptDesc && !item.receiptUrl && item.receiptStatus != '-1' && item.receiptStatus!='1' && item.receiptRevisitStatus!=5" class="statusBox">
            <div class="item-box">
              <span class="title1">回执操作指引:</span>
            </div>
            <div class="items" v-if="item.receiptDesc"><span v-for="(v, index) in item.receiptDesc.split('\n')" :key="index">{{ v }}<br /></span></div>
            <div class="items" v-else>暂无内容</div>
          </div>
          <div v-if="item.revisitUrl&& item.revisitStatus!=1" class="statusBox">
            <div class="item-box">
              <span class="title1">回访链接:</span>
              <img id="copy" @click="copy(item.revisitUrl)" src="@static/images/fuzhi.png" class="btn1" />
            </div>
            <div class="items">{{ item.revisitUrl }}</div>
          </div>
          <div v-if="item.revisitDesc && !item.revisitUrl && item.revisitStatus != '-1'&& item.revisitStatus!='3' && item.receiptRevisitStatus!=5" class="statusBox">
            <div class="item-box">
              <span class="title1">回访操作指引:</span>
            </div>
            <div class="items" v-if="item.revisitDesc"><span v-for="(v, index) in item.revisitDesc.split('\n')" :key="index">{{ v }}<br /></span></div>
            <div class="items" v-else>暂无内容</div>
          </div>
          <div class="oneButton">
            <div class="button" @click="openShow(item)">查看记录</div>
          </div>
        </div>
      </div>

      
      <div v-if="list.length<=0 && !listLoading" class="null">
        <img class="null-img" src="@static/images/null.png" />
        <span class="null-text">暂无内容</span>
      </div>
    </van-list>
    

    <van-dialog v-model="show" title="回执回访记录" :showConfirmButton="false">
      <div class="closeBtn" @click="show = false"><img src="@/static/images/close.png" /></div>
      <van-list v-model="loadingOne" :finished="finished1" class="history">
        <div v-for="(item, index) in historyData" :key="index" class="historyItem" :class="index+1 == historyData.length?'historyItem1':''">
          <div class="historyTitle">
            <div class="left">
              <div class="dian"></div>
              <div>{{ RECEIPT_STATUS[item.receiptStatus] }}</div>
              <div>{{ VERIFY_STATUS[item.revisitStatus] }}</div>
            </div>
            <div class="right">
              {{ item.updateTime | dateFormat('yyyy-MM-dd') }}
            </div>
          </div>
          <div class="historyContent">
            <div v-if="item.remark"><span>{{ item.remark }}</span></div>
            <div v-if="item.receiptUrl"><span>回执链接：</span><span @click="$app.openWeb(item.receiptUrl);" style="color: #236DFF;">{{ item.receiptUrl }}</span></div>
            <div v-if="item.revisitUrl"><span>回访链接：</span><span @click="$app.openWeb(item.revisitUrl);" style="color: #236DFF;">{{ item.revisitUrl }}</span></div>
          </div>
        </div>
        <div v-if="historyData.length<=0 && !loadingOne" class="null">
          <img class="null-img" src="@/static/images/null.png" />
          <span class="null-text">暂无内容</span>
        </div>
      </van-list>
      
    </van-dialog>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import Clipboard from 'clipboard';
export default {
  name: 'apps.returnVisit',
  mixins: [common],
  data() {
    return {
      loadingOne: false,
      finished1: false,
      searchValue: '',
      value: '1',
      receiptRevisitStatus1: '0',
      show: false,
      option: [
        { text: '保单号', value: '1' },
        { text: '产品名称', value: '2' },
        { text: '投保人', value: '3' }
      ],
      listLoading: false,
      finished: false,
      finishedText: '没有更多了',
      total: 0,
      pageNo: 1,
      list: [],
      historyData: {},
      POLICY_STATUS: {
        //保单状态 1已承保-1已退保0已终止2已中止
        '1': '已承保',
        '-1': '已退保',
        '0': '已终止',
        '2': '已中止'
      },
      tabNumData:{},
      RECEIPT_STATUS:{},
      VERIFY_STATUS:{}
    };
  },
  created(){
    //查字典
    this.getDicByType({
      type: "RECEIPT_STATUS",
    }).then((res) => {
      this.RECEIPT_STATUS = res;
    });
    this.getDicByType({
      type: "VERIFY_STATUS",
    }).then((res) => {
      this.VERIFY_STATUS = res;
    });
    this.getTabNum(true)
  },
  methods: {
    titleTab(val){
      if(val == 1){
        if(this.tabNumData.tab1){
          if(Number(this.tabNumData.tab1)<100){
            return '全部('+this.tabNumData.tab1+')'
          }else{
            return '全部(99+)'
          }
        }else{
          return '全部'
        }
      }else if(val == 2){
        if(this.tabNumData.tab2){
          if(Number(this.tabNumData.tab2)<100){
            return '待回执('+this.tabNumData.tab2+')'
          }else{
            return '待回执(99+)'
          }
        }else{
          return '待回执'
        }
      }else if(val == 3){
        if(this.tabNumData.tab3){
          if(Number(this.tabNumData.tab3)<100){
            return '待回访('+this.tabNumData.tab3+')'
          }else{
            return '待回访(99+)'
          }
        }else{
          return '待回访'
        }
      }else if(val == 4){
        if(this.tabNumData.tab4){
          if(Number(this.tabNumData.tab4)<100){
            return '已成功('+this.tabNumData.tab4+')'
          }else{
            return '已成功(99+)'
          }
        }else{
          return '已成功'
        }
      }
    },
    openShow(item) {
      this.show = true;
      this.getHistoryData(item);
    },
    getTabNum(val) {
      let params;
      if (this.value == '1') {
        params = {
          pageNo: this.pageNo,
          pageSize: 10,
          policyNo: this.searchValue,
          firstTab: "1",
        };
      } else if (this.value == '2') {
        params = {
          pageNo: this.pageNo,
          pageSize: 10,
          productName: this.searchValue,
          firstTab: "1",
        };
      } else if (this.value == '3') {
        params = {
          pageNo: this.pageNo,
          pageSize: 10,
          holderName: this.searchValue,
          firstTab: "1",
        };
      }
      this.$http({
        url: '/api/policyreceiptrecord/receiptRevisit/statistics',
        type: 'POST',
        data: params
      }).then(res => {
        this.tabNumData = res.data;
        if(val){
          if(this.tabNumData.tab2){
            this.receiptRevisitStatus1 = '2';
          }else if(this.tabNumData.tab3){
            this.receiptRevisitStatus1 = '3';
          }
        }
        params.secondTab = this.receiptRevisitStatus1;
        this.getList(params);
      });
    },
    getHistoryData(item) {
      this.historyData={};
      this.loadingOne = true;
      this.finished1 = false;
      this.$http({
        url: '/api/policyreceiptrecord/read/detail',
        type: 'GET',
        data: {
          policyNo:item.policyNo
        }
      }).then(res => {
        if(res.data){
          this.historyData = res.data;
        }
        this.loadingOne = false;
        this.finished1 = true;
        
      }).catch(()=>{
        this.loadingOne = false;
        this.finished1 = true;
      });
    },
    changeType() {
      this.pageNo = 1;
      this.getTabNum();
    },
    copy(text) {
      var clipboard = new Clipboard('#copy', {
        text: () => {
          return text;
        }
      });
      clipboard.on('success', e => {
        this.$notice.msg('复制成功');
        console.log(e);
        // 释放内存
        clipboard.destroy();
      });
    },
    //上拉加{载
    nextPage() {
      if (this.list.length == this.count) {
        this.finished = true;
        return;
      }
      this.pageNo++;
      this.getTabNum();
    },
    // 获取数据
    getList(params) {
      this.listLoading = true
      this.$http({
        url: '/api/policyreceiptrecord/read/list',
        type: 'POST',
        data: params
      }).then(res => {
        this.pageNo = res.current;
        this.count = res.total;
        if (res.current == 1) {
            this.list = [];
            this.finishedText = '';
        }
        this.list = this.list.concat(res.data);
        this.total = res.total;
        if(res.pages){
          if (res.current == res.pages) {
            this.finished = true;
            this.finishedText = '没有更多了';
          } else {
            this.finished = false;
          }
        }else{
          this.finished = true;
          this.finishedText = '';
        }
        this.listLoading = false;
      }).catch((res)=>{
        this.listLoading = false;
        console.log(res);
      })
      ;
    }
  }
};
</script>

<style lang="scss" scoped>
.returnVisit {
  a:link{
    color: #236DFF;
  }
  a:visited{
    color: #236DFF;
  }
  background: #F4F4F4;
  /deep/ .van-dropdown-menu__bar {
    background: #f4f4f4;
    box-shadow: 0 0 0 transparent;
    height: 100%;
    width: 198px;
    border-radius: 8px 0px 0px 8px;
  }
  /deep/ .van-tab--active .van-tab__text{
    color: #236DFF;
  }
  
  /deep/ .van-dropdown-menu__item {
    justify-content: flex-start;
    padding-left: 12px;
    width: 100%;
  }

  /deep/ .van-dropdown-menu__title {
    font-size: 28px;
    width: 80%;
  }

  /deep/ .van-dropdown-menu__title::after {
    border: 0;
    width: 24px;
    height: 24px;
    background-image: url('~@/static/images/triangle.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    transform: inherit;
    top: 50%;
    right: -18px;
  }

  /deep/ .van-dropdown-menu__title--active::after {
    transform: rotate(180deg);
    top: 35%;
  }

  /deep/ .van-button--normal{
    font-size: 28px;
  }


  .listContent{
    overflow: auto;
    height: calc(100vh - 190px);
  }


  .searchBox {
    width: 100%;
    height: 106px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    .twoBox {
      width: 584px;
      height: 66px;
      background: #f4f4f4;
      border-radius: 8px 0px 0px 8px;
      display: flex;
    }

    input {
      width: 100%;
      background: #f4f4f4;
      border: 0;
      border-radius: 0;
      border-left: 1px solid #dddddd;
      margin: 13px 0;
      padding-left: 20px;
      font-size: 26px;
    }

    .btn {
      width: 120px;
      height: 68px;
      border-radius: 0px 8px 8px 0px;
      font-size: 26px;
    }
  }

  .list-item {
    background: #fff;
    margin: 20px 25px;
    padding: 30px;
    border-radius: 10px;

    .receiptRevisitStatus {
      font-size: 26px;
      color: #ff5426;
      margin: 20px 0;

      &.green {
        color: green;
      }
    }

    .title {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
    }

    .content {
      .itemShow {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
      }

      .itemName {
        font-size: 28px;
        color: #666666;
      }

      .itemData {
        font-size: 28px;
        color: #333333;
        max-width: 400px;
        word-break: break-all;

        &.red {
          color: red;
        }
      }

      .statusBox {
        background: #f5f5f5;
        padding: 20px;
        margin-bottom: 20px;
        word-break: break-all;
        border-radius: 10px;

        .item-box {
          display: flex;
          justify-content: space-between;
        }

        .title1 {
          font-weight: 500;
          font-size: 28px;
          color: #333333;
          line-height: 38px;
        
        }

        .btn1 {
          width: 88px;
          height: 40px;
        }

        .items {
          font-weight: 400;
          font-size: 26px;
          color: #666666;
          line-height: 34px;
          margin-top: 15px;
        }
      }
    }

    .oneButton {
      display: flex;
      justify-content: flex-end;

      .button {
        width: 172px;
        height: 60px;
        border: 1px solid #236dff;
        border-radius: 8px;
        font-weight: 400;
        font-size: 28px;
        color: #236dff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .closeBtn {
    position: absolute;
    top: 20px;
    right: 30px;
    color: #888888;
    img{
      width: 28px;
      height: 28px;
    }
  }

  .history {
    margin-top: 30px;
    max-height: 60vh;
    overflow: auto;
    .historyItem1{
      .historyContent{
          border: 0 !important;
        }
    }
    .historyItem {
      margin-right: 40px;
      .historyTitle{
        display: flex;
        align-items: center;
        margin-left: 20px;
        font-size: 30px;
        color: #333333;
        line-height: 42px;
        justify-content: space-between;
        .dian {
          width: 20px;
          height: 20px;
          background: #BFBFBF;
          border-radius: 50%;
          margin-right: 12px;
        }
        .left{
          display: flex;
          align-items: center;
          font-weight: 500;
        }
        .right{
          font-weight: 400;
          font-size: 26px;
          color: #666666;
        }
      }
      

      .historyContent {
        transform: rotateZ(360deg);
        border-style: dashed ;
        border-width: 0 0 0 1px;
        border-color: #BFBFBF;
        padding-top: 15px;
        padding-bottom: 40px;
        padding-left: 20px;
        margin-left: 30px;
        font-weight: 400;
        font-size: 26px;
        color: #666666;
        line-height: 32px;
        word-break: break-all;
        div{
          margin-bottom: 10px;
        }
      }
    }
  }

}
/deep/ .van-cell{
  font-size: 30px;
}
.van-dialog{
  font-size: 34px;
  width: 85%;
  /deep/ .van-dialog__header{
    font-weight: 500;
  }
}
.van-button--info{
  background: #236DFF;
}
.null{
  padding-bottom: 50px;
}
</style>
